import { useCallback, useEffect, useRef, useState, useMemo, memo } from 'react'
import { isMobile } from 'react-device-detect'
import { useLocation, useParams, Params } from 'react-router-dom'
import styled from 'styled-components'
import { getFilterList } from '../../api/product'
import ProductCenterModal from '../../components/product/ProductCenterModal'
import ProductFilterCenterModal from '../../components/product/ProductFilterCenterModal'
import ProductFilterModal from '../../components/product/ProductFilterModal'
import ProductHeader from '../../components/product/ProductHeader'
import ProductItem from '../../components/product/ProductItem'
import ProductListItem from '../../components/product/ProductListItem'
import ProductModal from '../../components/product/ProductModal'
import ProductSortModal from '../../components/product/ProductSortModal'
import { useAppContext } from '../../components/provider/AppProvider'
import { useMyContext, CategoryDepth } from '../../components/provider/MyProvider'
import '../../css/Product.css'

import Category from '../Category'
import CategoryFourDepth from '../CategoryFourDepth'
import { imgURL } from '../Home'

import TagManager from 'react-gtm-module'
import { ProductSearchItem } from '../../@types/product'
import { sendSetAppsflyerEvent } from '../../js/postMessage'
import { MultiLevelCategory } from '@shopby/shop-sdk'

export type AllCategoryList = {
  categoryNo?: number
  label?: string
}

const ProductList = () => {
  // TODO: 상품 상세 정리하면서 필요한 상태만 남기고 나머지는 삭제 예정
  const [listItem, setListItem] = useState<ProductSearchItem[]>([]) //상품 아이템
  const [totalCount, setTotalCount] = useState<number>(0) //상품 리스트 개수
  const [isModal, setIsModal] = useState<boolean>(false)
  const [selectProductNo, setSelectProductNo] = useState<string>('')
  const [type, setType] = useState<string>('thumb')
  const [sortKeyword, setSortKeyword] = useState<string>('MD_RECOMMEND') //정렬값
  const [sortKeywordLabel, setSortKeywordLabel] = useState<string>('추천순') //정렬 텍스트
  const [sortDirection, setSortDirection] = useState<string>('DESC') //정렬 내림차순?오름차순
  const [isSort, setIsSort] = useState<boolean>(false) //정렬 팝업열기
  const [isFilter, setIsFilter] = useState<boolean>(false) //필터 팝업열기
  const [getMax, setGetMax] = useState<number>(1000000)
  const [getMin, setGetMin] = useState<number>(0)
  const [freeCheck, setFreeCheck] = useState<boolean>(false)
  const [filterApply, setFilterApply] = useState<boolean>(false)
  const [brandArray, setBrandArray] = useState<any>([])
  const [filterTotal, setFilterTotal] = useState<number>(0)
  const [filterMin, setFilterMin] = useState<number>(0)
  const [filterMax, setFilterMax] = useState<number>(1000000)
  const [max, setMax] = useState<number>(1000000)
  const [min, setMin] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [hasSentGtmEvent, setHasSentGtmEvent] = useState<boolean>(false) // GTM 이벤트가 전송되었는지 추적
  const [listItemCount, setListItemCount] = useState<number>(0) // 현재 리스트 아이템의 개수
  const [page, setPage] = useState<number>(1) //현재 페이지
  const [changeKeyword, setChangeKeyword] = useState<boolean>(false)
  const [cartidx, setCartidx] = useState<number>(0)

  // NOTE: 리팩토링 상태 값
  const [categoryDepth, setCategoryDepth] = useState<CategoryDepth>({})
  const [allCategoryList, setAllCategoryList] = useState<AllCategoryList[]>([])
  const [depthLabel, setDepthLabel] = useState<string | undefined>()
  const [categoryItems, setCategoryItems] = useState<MultiLevelCategory[]>([])
  const [categoryDepth2No, setCategoryDepth2No] = useState<number>(0)
  const [categoryDepth3No, setCategoryDepth3No] = useState<number>(0)
  const [categoryDepth4No, setCategoryDepth4No] = useState<number>(0)

  const obsRef = useRef(null) //observer Element
  const preventRef = useRef(true) //옵저버 중복 실행 방지
  const endRef = useRef(false) //모든 글 로드 확인
  const listItemRef = useRef<any>(false)

  const location = useLocation()
  const param = useParams()
  const { isAppView } = useAppContext()
  const { setScrollHeader, categories, findCategory } = useMyContext()

  const createCategoryDepth4 = useMemo(
    () => (result: CategoryDepth, threeDepno: string | undefined) =>
      [
        { categoryNo: Number(threeDepno), label: '전체' },
        ...(result?.depth3?.children || [])
          .filter((child: MultiLevelCategory) => child.categoryNo !== 0)
          .map((child: MultiLevelCategory) => ({
            categoryNo: child.categoryNo,
            label: child.label,
          })),
      ],
    []
  )

  //초기화
  useEffect(() => {
    setListItem([])
    setLoading(false)
    setHasSentGtmEvent(false)
    setPage(1)
    setListItemCount(0)
    // setSortDirection('DESC');
    // setType('thumb');
    // setSortKeyword('MD_RECOMMEND');
    // setSortKeywordLabel('추천순');
    // setCategoryDepth4No(0);
    endRef.current = false
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setLoading(true)
      setScrollHeader(true)
    }, 300)
  }, [])

  // 카테고리 설정
  const createCategoryDepth = useCallback((result: CategoryDepth, threeDepno: string | undefined) => {
    setCategoryDepth(result)
    setCategoryItems(result?.depth2?.children || [])
    setAllCategoryList(createCategoryDepth4(result, threeDepno))
  }, [])

  useEffect(() => {
    if (!param || !categories) return

    const { twoDepno, threeDepno, fourDepno } = param
    setCategoryDepth2No(Number(twoDepno))
    setCategoryDepth3No(Number(threeDepno))
    setCategoryDepth4No(Number(fourDepno))

    const result = findCategory(categories, Number(fourDepno))?.categoryDepth
    if (!result) return

    createCategoryDepth(result, threeDepno)
  }, [param, categories, createCategoryDepth])

  useEffect(() => {
    if (
      categoryDepth?.depth2 &&
      categoryDepth?.depth2?.children &&
      categoryDepth?.depth1?.categoryNo !== categoryDepth?.depth2?.categoryNo
    ) {
      const foundCategory = categoryDepth.depth2.children.find(
        (v: any) => v.categoryNo === categoryDepth?.depth3?.categoryNo
      )
      if (foundCategory?.label) {
        setDepthLabel(foundCategory.label) // 조건에 맞는 카테고리의 label 설정
      }
    } else {
      setDepthLabel('전체') // 조건이 일치하는 경우 '전체' 설정
    }
  }, [categoryDepth])

  useEffect(() => {
    setPage(1)
    setHasSentGtmEvent(true) // GTM 상태 초기화
    endRef.current = false
    setChangeKeyword((prev: boolean) => !prev)
  }, [type, sortKeyword, sortDirection, filterApply])

  const createGtmItemArray = (listItem: ProductSearchItem[], param: Readonly<Params<string>>) => {
    return listItem.map((el, idx) => ({
      item_id: String(el?.productNo),
      item_name: el?.productName,
      affiliation: '어바웃피싱',
      item_list_price: el?.salePrice,
      item_selling_price: el?.salePrice - el?.immediateDiscountAmt,
      price: el?.salePrice - el?.immediateDiscountAmt,
      item_total_discount: el?.immediateDiscountAmt,
      discount: 0,
      index: idx + 1,
      item_brand: el?.brandNameKo,
      item_category: categoryDepth?.depth1?.label,
      item_category2: categoryDepth?.depth2?.label,
      item_category3: categoryDepth?.depth3?.label,
      item_list_id: String(param.fourDepno),
      item_list_name: categoryDepth?.depth2?.label,
    }))
  }

  const sendGtmEvent = (
    listItem: ProductSearchItem[],
    totalCount: number,
    isAppView: boolean,
    param: Readonly<Params<string>>
  ) => {
    const array = createGtmItemArray(listItem, param)

    const gtmViewItem = {
      dataLayer: {
        event: 'view_item_list',
        ecommerce: {
          item_list_count: totalCount,
          items: array,
        },
      },
    }

    if (isAppView) {
      sendSetAppsflyerEvent({
        eventName: 'view_item_list',
        eventType: {
          item_list_count: totalCount,
          items: array,
        },
      })
    } else {
      TagManager.dataLayer(gtmViewItem)
    }
  }

  useEffect(() => {
    if (!param || !categories) return

    const { fourDepno } = param
    if (loading) {
      if (categoryDepth4No === Number(fourDepno)) {
        if (page === 1 && !hasSentGtmEvent && totalCount > 10 && listItemCount > 0) {
          sendGtmEvent(listItem, totalCount, isAppView, param)
          setHasSentGtmEvent(true)
        } else if (listItem.length > 0 && listItem.length !== listItemCount) {
          sendGtmEvent(listItem, totalCount, isAppView, param)
          setHasSentGtmEvent(true)
        }
        setListItemCount(listItem.length)
      }
    }
  }, [listItem, loading])

  const updateListItems = (newItems: ProductSearchItem[], page: number) => {
    setListItem((prev: ProductSearchItem[]) => (page === 1 ? newItems : [...prev, ...newItems]))
  }

  const getPost = useCallback(async () => {
    if (categoryDepth4No <= 0) return

    try {
      const res = await getFilterList(
        sortKeyword,
        page,
        categoryDepth4No,
        sortDirection,
        brandArray.join(','),
        getMin,
        getMax,
        freeCheck
      )

      updateListItems(res.data.items, page)
      setTotalCount(res.data.totalCount)

      // 마지막 페이지일 경우
      if (res.data.pageCount <= page) endRef.current = true
    } catch (err) {
      console.error('Error fetching posts:', err)
    }
  }, [page, changeKeyword, categoryDepth4No])

  useEffect(() => {
    preventRef.current = true
    getPost()
  }, [getPost])

  useEffect(() => {
    setTimeout(() => {
      setFilterApply((prev: boolean) => !prev)
    }, 200)
  }, [])

  useEffect(() => {
    if (!filterApply || isFilter) return
    setFilterMin(getMin)
    setFilterMax(getMax)
  }, [isFilter, filterApply])

  //필터용
  useEffect(() => {
    if (!filterApply) return
    let filterTotal = 0
    if (brandArray.length > 0 || freeCheck) filterTotal = freeCheck ? brandArray.length + 1 : brandArray.length
    if (getMax !== 1000000 || getMin !== 0) filterTotal += 1
    setFilterTotal(filterTotal)
  }, [brandArray, freeCheck, filterMax, filterMin, getMin, getMax, filterApply])

  useEffect(() => {
    if (!isFilter) return
    setFilterApply(false)
  }, [isFilter])

  useEffect(() => {
    const footer = document.querySelector('.footer_wrap') as HTMLElement
    if (isMobile) {
      footer.style.paddingBottom = '36px'
    }
  }, [])

  const obsHandler = (entries: any) => {
    //옵저버 콜백함수
    const target = entries[0]
    if (!endRef.current && target.isIntersecting && preventRef.current) {
      //옵저버 중복 실행 방지
      preventRef.current = false //옵저버 중복 실행 방지
      setPage((prev) => prev + 1) //페이지 값 증가
    }
  }

  useEffect(() => {
    if (!listItem) return

    const mutationObserver = new MutationObserver(() => {
      if (obsRef.current && listItemRef.current) {
        const observer = new IntersectionObserver(obsHandler, { threshold: 0.6 })
        observer.observe(obsRef.current)
        mutationObserver.disconnect() // 초기화 후 더는 필요 없으므로 중단

        return () => observer.disconnect()
      }
    })

    mutationObserver.observe(document.body, { childList: true, subtree: true })

    return () => mutationObserver.disconnect()
  }, [listItem, listItemRef])

  const renderProductItem = useCallback(
    (el: any, idx: number) => (
      <ProductItem
        item={el}
        key={`${el.productNo}-${idx}`}
        setIsModal={setIsModal}
        setSelectProductNo={setSelectProductNo}
        page={page}
        listItem={listItem}
        categoryDepth1={categoryDepth?.depth1}
        categoryDepth2={categoryDepth?.depth2}
        categoryDepth3={categoryDepth?.depth3}
        depthLabel={depthLabel}
        idx={idx}
        totalCount={Number(totalCount)}
        setCartIdx={setCartidx}
      />
    ),
    [listItem]
  )

  const renderProductListItem = useCallback(
    (el: any, idx: number) => (
      <ProductListItem
        item={el}
        listItem={listItem}
        idx={idx}
        key={`${el.productNo}-${idx}`}
        setIsModal={setIsModal}
        setSelectProductNo={setSelectProductNo}
        page={page}
        categoryDepth1={categoryDepth?.depth1}
        categoryDepth2={categoryDepth?.depth2}
        categoryDepth3={categoryDepth?.depth3}
        depthLabel={depthLabel}
        totalCount={Number(totalCount)}
        setCartIdx={setCartidx}
      />
    ),
    [listItem]
  )

  return (
    <>
      <div className='main_wrap'>
        {/* 카테고리 */}
        {categoryDepth && categoryItems.length > 0 && (
          <Category
            item={categoryItems}
            categoryDepth2Label={categoryDepth?.depth2?.label}
            categoryDepth2No={categoryDepth2No || 0}
            categoryDepth3No={categoryDepth3No || 0}
            categoryDepth4No={categoryDepth4No || 0}
            setCategoryDepth3No={setCategoryDepth3No}
            setCategoryDepth4No={setCategoryDepth4No}
            setPage={setPage}
            setHasSentGtmEvent={setHasSentGtmEvent}
          />
        )}

        {/* 카테고리 4dept */}
        {categoryDepth2No !== categoryDepth4No && (
          <CategoryFourDepth
            item={allCategoryList}
            categoryDepth2No={categoryDepth2No}
            categoryDepth3No={categoryDepth3No}
            categoryDepth4No={categoryDepth4No}
            setPage={setPage}
          />
        )}

        {/* 상품 목록 전체 wrap */}
        <div className={location.pathname.includes('category') ? 'product_list_wrap product' : 'product_list_wrap'}>
          {/* 상품목록 header */}
          <ProductHeader
            totalCount={totalCount}
            type={type}
            setSortDirection={setSortDirection}
            sortDirection={sortDirection}
            setSortKeywordLabel={setSortKeywordLabel}
            setType={setType}
            isSort={isSort}
            setIsSort={setIsSort}
            sortKeyword={sortKeyword}
            setSortKeyword={setSortKeyword}
            sortKeywordLabel={sortKeywordLabel}
            setIsFilter={setIsFilter}
            filterTotal={filterTotal}
          />

          {/* 상품 Item Wrap */}
          {loading &&
            (brandArray || freeCheck || filterApply ? (
              listItem.length !== 0 ? (
                <>
                  <div className={type === 'thumb' ? 'product_wrap' : 'product_wrap list'} ref={listItemRef}>
                    {listItem.map((el: any, idx: number) =>
                      type === 'thumb' ? renderProductItem(el, idx) : renderProductListItem(el, idx)
                    )}
                    {/* {listItem.map((el: any, idx: number) =>
                      type === 'thumb' ? (
                        <ProductItem
                          item={el}
                          key={`${el.productNo}-${idx}`}
                          setIsModal={setIsModal}
                          setSelectProductNo={setSelectProductNo}
                          page={page}
                          listItem={listItem}
                          one={categoryDepth?.depth1}
                          twoDepCategory={categoryDepth?.depth2}
                          thirdDepLabel={depthLabel}
                          idx={idx}
                          totalCount={Number(totalCount)}
                          setCartIdx={setCartidx}
                        />
                      ) : (
                        <ProductListItem
                          item={el}
                          listItem={listItem}
                          idx={idx}
                          key={`${el.productNo}-${idx}`}
                          setIsModal={setIsModal}
                          setSelectProductNo={setSelectProductNo}
                          page={page}
                          one={categoryDepth?.depth1}
                          twoDepCategory={categoryDepth?.depth2}
                          thirdDepLabel={depthLabel}
                          totalCount={Number(totalCount)}
                          setCartIdx={setCartidx}
                        />
                      ),
                    )} */}
                  </div>
                  <div ref={obsRef} style={{ height: '20px' }}></div>
                </>
              ) : (
                <div className='product_list_wrap empty'>
                  <div className='no_data'>
                    <img src={`${imgURL}/empty_logo.png`} alt='' />
                    <p>상품이 없습니다.</p>
                  </div>
                </div>
              )
            ) : (
              <div className='product_list_wrap'>
                <div className='no_data'>
                  <p className='tit_txt'>상품이 없습니다.</p>
                  <p className='sub_txt'>선택한 필터를 변경해 보세요.</p>
                  <button
                    className='btn_black'
                    onClick={() => {
                      setBrandArray([])
                      setFreeCheck(false)
                      setGetMax(1000000)
                      setGetMin(0)
                      setFilterMax(1000000)
                      setFilterMin(0)
                      setFilterApply(true)
                    }}
                  >
                    필터 초기화
                  </button>
                </div>
              </div>
            ))}
        </div>

        {isMobile && isSort && (
          <ProductSortModal
            headerText='정렬'
            setIsModal={setIsSort}
            setSortKeyword={setSortKeyword}
            sortKeyword={sortKeyword}
            setSortKeywordLabel={setSortKeywordLabel}
            setSortDirection={setSortDirection}
            sortDirection={sortDirection}
          />
        )}

        {isModal &&
          (isMobile ? (
            <ProductModal
              setIsModal={setIsModal}
              listItem={listItem}
              headerText={'옵션선택'}
              selectProductNo={selectProductNo}
              idx={cartidx}
            />
          ) : (
            <ProductCenterModal
              setIsModal={setIsModal}
              headerText={'옵션선택'}
              selectProductNo={selectProductNo}
              listItem={listItem}
              idx={cartidx}
            />
          ))}

        {isFilter &&
          (isMobile ? (
            <ProductFilterModal
              isCategoryModal={isFilter}
              setIsCategoryModal={setIsFilter}
              setFreeCheck={setFreeCheck}
              setGetMax={setGetMax}
              setGetMin={setGetMin}
              setFilterApply={setFilterApply}
              setBrandArray={setBrandArray}
              brandArray={brandArray}
              freeCheck={freeCheck}
              max={max}
              filterMax={filterMax}
              setMax={setMax}
              min={min}
              filterMin={filterMin}
              setMin={setMin}
            />
          ) : (
            <ProductFilterCenterModal
              isCategoryModal={isFilter}
              setIsCategoryModal={setIsFilter}
              setFreeCheck={setFreeCheck}
              setGetMax={setGetMax}
              setGetMin={setGetMin}
              setFilterApply={setFilterApply}
              setBrandArray={setBrandArray}
              brandArray={brandArray}
              freeCheck={freeCheck}
              max={max}
              filterMax={filterMax}
              setMax={setMax}
              min={min}
              filterMin={filterMin}
              setMin={setMin}
            />
          ))}

        <div ref={obsRef} style={{ height: '1px' }}></div>
      </div>
    </>
  )
}

export default memo(ProductList)

// 상품목록 헤더영역 wrap
export const ProductListHeder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
  @media screen and (min-width: 768px) {
    padding: 14px 0;
  }
`

export const ProductListNum = styled.div`
  color: var(--colGray6);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  & span {
    color: var(--colBlack);
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
`

// 상품목록 헤더옵션(정렬, 필터, 상품목록 보기정렬 버튼)
export const ProductListOption = styled.ul`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & li {
    position: relative;
    & img {
    }
    @media screen and (min-width: 768px) {
      &:first-of-type {
      }
      &:nth-of-type(2) {
      }
      &:last-of-type {
      }
    }
    & .sort_layer {
      @media screen and (min-width: 768px) {
        position: absolute;
        top: 32px;
        right: 0;
        min-width: 135px;
        border-radius: 8px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
        background: var(--colWhite);
        z-index: 10;
        & ul {
          padding: 6px 32px 6px 16px;
          & li > a {
            display: block;
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
            color: var(--colGray5);
            padding: 10px 0;
          }
          & li.on a {
            color: var(--colBlack);
            font-weight: 600;
          }
        }
      }
    }
  }
  & > li::after {
    content: '';
    position: absolute;
    top: calc(50% - (14px / 2));
    right: 0;
    width: 1px;
    height: 14px;
    background: var(--colGray3);
  }
  & > li:last-child {
    padding-left: 12px;
  }
  & > li:last-child::after {
    display: none;
  }
`

// 상품목록 영역 wrap
export const ProductWrap = styled.div<{ listType: string }>`
  font-size: 14px;
  display: grid;
  grid-template-columns: ${(props) => (props.listType === 'thumb' ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)')};
  grid-gap: ${(props) => (props.listType === 'thumb' ? '30px 12px' : '16px')};

  @media screen and (min-width: 768px) {
    grid-template-columns: ${(props) => (props.listType === 'thumb' ? 'repeat(4, 1fr)' : 'repeat(1, 1fr)')};
    grid-gap: 48px 16px;
    margin-bottom: 84px;
  }
`
